<!--
 * @Author: xuesong
 * @Date: 2021-04-26 13:39:30
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-12 18:22:43
 * @Description: 7 完善健康档案
-->
<template>
<div class="custom-7" :style="{backgroundColor: bgColor,color: color}">
  <div class="info-content" >
    <div class="left-img">
      <img
        src="../../static/IM/patient-case@2x.png"
        alt=""
      />
    </div>
    <div class="seytm_text">
      <div class="seytm_text_title">{{ data.title }}</div>
      <div class="seytm_text_content">{{ data.content }}</div>
    </div>
  </div>
</div>

</template>

<script>
export default {
props:{
    data:{
      type: Object,
      default: ()=>{}
    },
     bgColor:{
      type: String,
      default: '#F5F5F5'
    },
    color:{
      type: String,
      default: '#333'
    }
  }
}
</script>

<style lang="less" scoped>
.custom-7{
  border-radius: 4px;    
 .info-content {
    display: flex;
    align-items: center;
    word-break: break-all;
    
    padding:10px;
    font-size: 12px;
    font-weight: 500;

    text-align: left;
    display: flex;
    .left-img {
      margin-right: 15px;
      img {
        height: 60px;
        width: 60px;
      };
    }
    .seytm_text {
      font-size: 14px;
      .seytm_text_title {
        font-size: 12px;
        font-weight: 600;
        color: #333;
      }
      .seytm_text_content {
        font-size: 12px;
        color: #333333;
      }
    }
  }
}

</style>